/**
 * Why an address is on the never-email list, in words. `invalid:<status>`
 * is a failed verification; its status says how.
 */
const FAILED = { label: 'Failed verification', color: 'grape' };

export const REASONS: Record<string, { label: string; color: string }> = {
  unsubscribe: { label: 'Unsubscribed', color: 'gray' },
  bounce: { label: 'Bounced', color: 'chartAmber' },
  complaint: { label: 'Marked as spam', color: 'red' },
  invalid: FAILED,
  sunset: { label: 'Never engaged', color: 'blue' },
  manual: { label: 'Added by hand', color: 'gray' },
};

const INVALID: Record<string, string> = {
  invalid_syntax: 'not a valid address',
  typo: 'a misspelt domain',
  disposable: 'a throwaway inbox',
  invalid_mx: 'the domain takes no mail',
  dead_server: 'the mail server is dead',
  email_disabled: 'the mailbox does not exist',
  spamtrap: 'a spam trap',
};

export function reasonInfo(reason: string): { label: string; color: string; detail: string } {
  if (reason.startsWith('invalid:')) {
    const status = reason.slice('invalid:'.length);
    return { ...FAILED, detail: INVALID[status] ?? status.replace(/_/g, ' ') };
  }
  return { ...(REASONS[reason] ?? { label: reason, color: 'gray' }), detail: '' };
}

/** What a verification status means, for the overview. */
export function statusLabel(status: string): string {
  const known: Record<string, string> = {
    ok: 'Deliverable',
    ok_for_all: 'Accept-all domain',
    free_ok: 'Passed free checks',
    unknown: 'Unclear',
    smtp_protocol: 'Unclear (server would not say)',
    antispam_system: 'Unclear (anti-spam)',
  };
  return known[status] ?? (INVALID[status] ? `Invalid: ${INVALID[status]}` : status.replace(/_/g, ' '));
}
